module.exports = __webpack_public_path__ + "static/assets/1c8b575f37b1a519fc3cdc5183bb85c0.mp3";